module.exports = __webpack_public_path__ + "img/group-logo.a113ecfc.svg";